export default "__VITE_ASSET__Ck8Q9qrg__"